<template>
  <div style="padding: 10px; background: #f4f3ef">
    <div class="box box-primary">
      <div class="box-header with-border">
        <button
          type="button"
          class="btn btn-labeled btn-primary pull-right"
          @click="onAddImg"
          style="margin-right: 5px;"
        >
          <span class="btn-label"> <i class="fa fa-plus"></i> </span>
          {{ $t("common.addnew") }}
        </button>
      </div>
      <div class="box-body">
        <b-table striped hover :items="imgItems" :fields="imgFields" responsive>
          <template #head()="scope">
            <div class="">{{ $t(scope.label) }}</div>
          </template>
          <template #cell(imgUrl)="row">
            <img
              class="asset-img-class img-responsive"
              :src="row.item.imgUrl"
              alt=""
              @click="onViewImgNewTab(row.item.imgUrl)"
            />
          </template>
          <template #cell(actions)="row">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-danger dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="true"
              >
                <i class="fa fa-fw fa-ellipsis-h"></i>
              </button>
              <ul class="dropdown-menu" style="min-width: 50px">
                <li>
                  <button
                    v-if="
                      GET_ACCOUNT_DATA.id == 1 || has_perm('update_apartment')
                    "
                    class="btn btn-primary btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenEditInput(row.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                </li>
                <li style="margin-top: 5px">
                  <button
                    v-if="
                      GET_ACCOUNT_DATA.id == 1 || has_perm('delete_apartment')
                    "
                    class="btn btn-danger btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenDelete(row.item)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </li>
              </ul>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <apartment-img-component
      :apartment-id="apartmentId"
      ref="ApartmentImgComponent"
    />
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import ApartmentImgComponent from "./ApartmentImgComponent";
import LTEModal from "@/components/LTEModal.vue";
import Enum from "../../../enum/enum";
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";

export default {
  components: {
    ApartmentImgComponent,
    "lte-modal": LTEModal
  },
  data: () => ({
    imgFields: [
      {
        key: "nonumber",
        label: "common.nonumber"
      },
      {
        key: "imgUrl",
        label: "banner.image"
      },
      {
        key: "description",
        label: "common.description"
      },
      { key: "actions", label: "common.action" }
    ],
    imgItems: [],
    apartmentId: null,
    isModalVisible: false,
    originalRecordData: null,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ]
  }),
  watch: {
    GET_APARTMENT_IMG_LIST_DATA: function() {
      let data = this.GET_APARTMENT_IMG_LIST_DATA;
      this.imgItems = [];
      data.forEach((value, index) => {
        let item = {
          id: value.id,
          nonumber: index + 1,
          imgUrl: value.img_url,
          description: value.description,
          apartmentImgType: value.type
        };
        this.imgItems.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_APARTMENT_IMG_LIST_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onAddImg: function() {
      this.$refs.ApartmentImgComponent.onShowAddNew(
        Enum.ApartmentImgType.APARTMENT_IMG
      );
    },
    onOpenEditInput: function(data) {
      this.$refs.ApartmentImgComponent.onShowDetail(data);
    },
    onViewImgNewTab: function(data) {
      window.open(data);
    },
    onOpenDelete: function(data) {
      this.originalRecordData = data;
      this.isModalVisible = true;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_APARTMENT_IMG(this.originalRecordData)
        .then(
          function() {
            this.getApartmentImg();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getApartmentImg: function() {
      let filter = {
        params: {
          apartmentId: this.apartmentId,
          type: Enum.ApartmentImgType.APARTMENT_IMG
        }
      };
      this.GET_APARTMENT_IMG_LIST(filter);
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_APARTMENT_IMG_LIST",
      "DELETE_APARTMENT_IMG"
    ])
  },
  mounted() {
    let id = this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.apartmentId = parseInt(id);
      let imgFilter = {
        params: {
          apartmentId: id,
          type: Enum.ApartmentImgType.APARTMENT_IMG
        }
      };
      this.GET_APARTMENT_IMG_LIST(imgFilter);
    }
  }
};
</script>
<style scoped>
.asset-img-class {
  width: 100%;
  max-width: 75px;
  max-height: 100px;
  object-fit: contain;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentImgWithExtraInfo.vue